/** @format */
import React from "react";

export const LongTextPreference = ({ children }) => (
  <div className="LongTextPreference">{children || "Not set"}</div>
);
